import { render, staticRenderFns } from "./ScientificTipsInfo.vue?vue&type=template&id=187b2b82&scoped=true&"
import script from "./ScientificTipsInfo.vue?vue&type=script&lang=js&"
export * from "./ScientificTipsInfo.vue?vue&type=script&lang=js&"
import style0 from "./ScientificTipsInfo.vue?vue&type=style&index=0&id=187b2b82&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b2b82",
  null
  
)

export default component.exports